import { ValuesRef } from '../types';
import { canDraftBeApplied } from './canDraftBeApplied';

export function handleDraftApply(values: ValuesRef) {
  if (canDraftBeApplied(values)) {
    values.current.props.onChange(values.current.draftDates);
  }
  values.current.setIsOpen(false);
}
